//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { helper } from '~/mixins/helper'
import { mapGetters, mapActions } from "vuex"
import { BPaginationNav, VBPopover, VBModal } from 'bootstrap-vue'

import Vue from 'vue'
Vue.directive('b-modal', VBModal)
Vue.directive('b-popover', VBPopover)

export default {

    name: "Companies",

    components: { BPaginationNav },

    mixins: [helper],

    scrollToTop: true,

    props: {
        type: {
            type: String,
        },
        country: {
            type: String,
        },
        term: {
            type: String,
        },
        slug: {
            type: String,
        },
        page: {
            type: String,
            default: "1"
        },
    },

    data() {
        return {
            loadmorePage: 0,
            xLastPosition: 0,
            yLastPosition: 0,
        }
    },

    watch: {
        $route(to, from) {
            this.loadmorePage = parseInt(this.page) + 1
        },
    },

    created() {
        this.loadmorePage = parseInt(this.page) + 1
    },

    methods: {

        ...mapActions('search', {
            addToCart: 'addItem',
            doLoadMore: 'doLoadMore'
        }),

        onRequestMeeting(company) {
            this.$bus.$emit('request-meeting', company)
        },

        openNewTab(url) {
            window.open(url, '_blank')
        },

        linkGen(pageNum) {

            let pagePath = this.meta.path

            if(pageNum !== 1) {
                pagePath = pagePath + '/page/' + pageNum
            }

            pagePath = this.addQueryParams(pagePath)

            return {
                path: pagePath,
            }
        },

        addQueryParams(pagePath) {

            if(this.type === 'name' || this.queryFilter) {
                pagePath = pagePath + '?'
            }

            if(this.type === 'name') {
                pagePath = pagePath + 'q=' + this.queryQ
            }

            if(this.queryFilter) {

                let add = '';
                const filter = 'filter=' + this.queryFilter

                if(this.type === 'name') {
                    add = '&'
                }

                pagePath = pagePath + add + filter
            }

            return pagePath

        },

        async loadMore() {

            this.xLastPosition = window.pageXOffset
            this.yLastPosition = window.pageYOffset

            let term;

            if(this.type === 'name') {
                term = this.queryQ
            } else {
                term = this.term
            }

            var payload = {type: this.type, page: this.loadmorePage, term: term, country: this.country, slug: this.slug, filter: this.queryFilter}

            try {
                const response = await this.doLoadMore(payload)

                if (response.result.length) {

                    this.loadmorePage += 1;

                    this.$nextTick(() => {
                        window.scroll(this.xLastPosition, this.yLastPosition)
                    })

                }

            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        // Add Item to Sidebar for more info
        AddItemToSidebar(company) {

            if(this.sidebarCart && this.sidebarCart.id === company.id) {
                this.isOpen = false;
                return
            }

            this.$store.dispatch("search/AddItemToSidebar", company);
            if (!this.isOpen) {
                this.isOpen = true;
            }
            this.currentComponent = "MoreInfo";
        },
        // Toggle Like Button
        ToggleLike(company) {
            const isLiked = !company.isLiked;
            if (isLiked) {
                this.AddToFavorite(company)
            }
            if (!isLiked) {
                this.RemoveFromFavorite(company)
            }
        },
        // Add Item To Favorite Card
        AddToFavorite(company) {
            this.$store.dispatch("search/addToFavorites", company);
        },
        // Remove Item To Favorite Card
        RemoveFromFavorite(company) {
            this.$store.dispatch("search/removeFromFavorites", company);
        },

    },


    computed: {

        ...mapGetters('search', ['companies', 'meta', 'links', 'sidebarCart']),

        icons() {
            return {
                gmcs: require(`~/assets/images/icons/gmcs.png?size=200`),
                verified: require(`~/assets/images/icons/verified-member.png?size=200`)
            }
        },

        gmcsPopover() {
            return {
                //title:'GMCS',
                content:"<div class='text-center'><a target='_blank' href='/gmcs'><img height='100px' src='"+ this.icons['gmcs'] +"' /></a></div><div class='text-center'><a target='_blank' href='/gmcs'>What is GMCS?</a></div>",
                html: true
            }
        },

        verifiedPopover() {
            return {
                //title:'Verified Member',
                content:"<div class='text-center'><a target='_blank' href='/faq/search?q=verified%20membership&open=true'><img height='100px' src='"+ this.icons['verified'] +"' /></a></div><div class='text-center'><a target='_blank' href='/faq/search?q=verified%20membership&open=true'>What is a verified member?</a></div>",
                html: true
            }
        },

        currentPage() {
            return this.meta.current_page
        },

        lastPage() {
            return this.meta.last_page
        },


        // to open the side bar
        isOpen: {
            get() {
                return this.$store.state.search.isOpen;
            },
            set(value) {
                this.$store.commit("search/isOpen", value);
            },
        },

        currentComponent: {
            get() {
                return this.$store.state.search.currentComponent;
            },
            set(value) {
                this.$store.commit("search/currentComponent", value);
            },
        },

        queryFilter() {
            return this.$route.query.filter
        },

        paginationData() {
            return {
                links: this.links,
                meta: this.meta
            }
        },

        showLoadMore() {
            return this.loadmorePage <= this.meta.last_page
        },

        showPagination() {
            return this.meta.last_page > 1
        },

        queryQ() {
            return this.$route.query.q
        },

        isCrawler() {
            return this.$store.state.isCrawler
        },

        paginationClass() {

            return {
                'd-none': !this.isCrawler,
                'd-sm-block': !this.isCrawler
            }

        }

    },
}
